import Vue                       from "vue";
import VueRouter                 from "vue-router";
import { router }                from "@/routes";
import { store }                 from "@/store";
import App                       from "./App.vue";
import VueI18n                   from "vue-i18n";
import i18n                      from "@/i18n/main";
import { translator }            from "@/i18n/translator";
import { http }                  from "@/http";
import User                      from "@/utils/User";
import * as Sentry               from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

i18n.locale = store.getters.locale;
translator.lang = store.getters.locale;

http.interceptors.response.use(res => res, async err => {
    const originalRequest = err.config;
    if (err.response.status === 401 && store.getters.user.hasCredentials) {
        try {
            const response = await http.post("/check-pin-code/", {
                uuid: store.getters.user.docsetID,
                code: store.getters.user.pinCode
            });
            const user = Object.assign(new User(), store.getters.user);
            user.token = response.data.token;
            store.commit("set_user", user);
            originalRequest.headers["Authorization"] = "Bearer " + response.data.token;
            return await http.request(originalRequest);
        } catch (e) {
            await router.push({
                name: "errorView",
                params: {
                    status: err.response.status,
                    message: err.response.statusText
                }
            });
        }
    }
    return Promise.reject(err);
});

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.prototype.$http = http;

Sentry.init({
    dsn: "https://7a588f4601694d78b02e55f1a5954994@o428048.ingest.sentry.io/5372978",
    integrations: [new VueIntegration({ Vue, attachProps: true })],
});

new Vue({
    i18n,
    store,
    router,
    render: h => h(App),
}).$mount("#app");
